import i18n from "@/plugins/i18n";

export enum FeatureType {
	/// <summary>
	/// Default
	/// </summary>
	Undefined,

	/// <summary>
	/// Defines an anchor face to color the faces properly
	/// </summary>
	AnchorFace,

	/// <summary>
	/// Currently not used
	/// </summary>
	BottomFace,

	/// <summary>
	/// Currently not used
	/// </summary>
	SideFace,

	/// <summary>
	/// Defines a single bend line in the scdoc
	/// </summary>
	Bend,

	/// <summary>
	/// Defines a cylindric hole. Screw threds and extruded threads are
	/// also holes, before they are confirmed.
	/// </summary>
	Hole,

	/// <summary>
	/// Defines a cutout. In contrast to a hole, the outline is free.
	/// </summary>
	Cutout,

	/// <summary>
	/// Defines a screw thread (Gewinde). This is always confirmed.
	/// </summary>
	ScrewThread,

	/// <summary>
	/// Defines a countersink (Senkung). This can be confirmed or not.
	/// </summary>
	Countersink,

	/// <summary>
	/// Defines an extruded thread (Durchzug). This is always confirmed.
	/// </summary>
	ExtrudedThread,

	/// <summary>
	/// Defines an engraving. This can be confirmed or not.
	/// </summary>
	Engraving,

	/// <summary>
	/// Defines an invalid features. The exact type can be determind by
	/// reading the invalid feature type.
	/// </summary>
	Invalid,

	/**
	 * Defines a weldline feature. This is always confirmed.
	 */
	Weldline,

	/**
	 * Defines a hole which fits a cylinder head bolt (Zylinderkopfschraube)
	 */
	CylinderHeadBoltHole,

	/**
	 * Defines holes for press join parts
	 */
	PressJoin,
}

export function getFeatureTypeName(featureType: FeatureType): string {
	const t = i18n.global.t;
	const friendlyNames: Record<FeatureType, string> = {
		[FeatureType.Undefined]: t("common.featureType.undefined"),
		[FeatureType.AnchorFace]: t("common.featureType.anchorFace"),
		[FeatureType.BottomFace]: t("common.featureType.bottomFace"),
		[FeatureType.SideFace]: t("common.featureType.sideFace"),
		[FeatureType.Bend]: t("common.featureType.bend"),
		[FeatureType.Hole]: t("common.featureType.hole"),
		[FeatureType.Cutout]: t("common.featureType.cutout"),
		[FeatureType.ScrewThread]: t("common.featureType.screwThread"),
		[FeatureType.Countersink]: t("common.featureType.countersink"),
		[FeatureType.ExtrudedThread]: t("common.featureType.extrudedThread"),
		[FeatureType.Engraving]: t("common.featureType.engraving"),
		[FeatureType.Invalid]: t("common.featureType.invalid"),
		[FeatureType.Weldline]: t("common.featureType.weldline"),
		[FeatureType.CylinderHeadBoltHole]: t("common.featureType.cylinderHeadBoltHole"),
		[FeatureType.PressJoin]: t("common.featureType.pressJoin"),
	};
	return friendlyNames[featureType] ?? t("common.featureType.unknown");
}
